const InvoiceHeaderStyles = {
  logoCell: {
    "&.MuiTableCell-root.MuiTableCell-root": {
      padding: "0px",
      fontFamily: "Inter",
    },
    width: "15%",
    borderRight: "3px solid #000000",
    borderBottom: "3px solid #000000",
  },
  headerCell: {
    "&.MuiTableCell-root.MuiTableCell-root": {
      padding: "0px",
      fontFamily: "Inter",
    },
    fontWeight: "bold",
    fontSize: "15px",
    textAlign: "center",
    borderBottom: "2px solid #000000",
  },
  subHeaderCell: {
    "&.MuiTableCell-root.MuiTableCell-root": {
      padding: "0px",
      fontFamily: "Inter",
    },
    fontWeight: "bold",
    fontSize: "13px",
    textAlign: "center",
  },
  addressCell: {
    "&.MuiTableCell-root.MuiTableCell-root": {
      padding: "2px",
      fontFamily: "Inter",
    },
    textAlign: "left",
    borderTop: "2px solid #000000",
    fontSize: "9px",
  },
  factoryAddressCell: {
    "&.MuiTableCell-root.MuiTableCell-root": {
      padding: "8px 0px 8px 2px",
      fontFamily: "Inter",
    },
    textAlign: "left",
    borderTop: "2px solid #000000",
    fontSize: "9px",
  },
  footerCell: {
    "&.MuiTableCell-root.MuiTableCell-root": {
      fontWeight: 400,
      padding: "3px",
      fontFamily: "Inter",
    },
    textAlign: "center",
    fontSize: "9px",
    borderTop: "2px solid #000000",
    borderBottom: "3px solid #000000",
  },
};

export default InvoiceHeaderStyles;
